<template>
  <div>
    <b-card style="height: 100vh">
      <div v-if="loading" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)" class="text-center">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <div v-else-if="dataList.length === 0" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)" class="text-center">
        <div>未查询到数据</div>
        <b-icon-exclamation-triangle-fill scale="5" class="my-3" />
        <div class="text-muted">No items found</div>
      </div>
      <b-row v-else class="mb-0">
        <b-col cols="12" class="p-0">
          <vue-perfect-scrollbar v-if="dataList.length" style="height: 100%">
            <b-list-group flush class="listGroupContent mb-1">
              <b-list-group-item
                v-for="(items, index) of dataList"
                @click.stop="openChat(items[0])"
                :key="index"
                :style="items[0].id === detailModal.data.id && selectIds.length <= 1 ? `box-sizing: border-box; border-left: 3px solid #1890ff;` : ''"
                class="cursor-pointer px-2 py-1"
              >
                <b-row>
                  <b-col cols="12" class="d-flex align-items-center">
                    <div style="min-width: 0">
                      <h5 class="d-flex align-items-center">
                        <span class="bullet bullet-sm mr-1" :class="'bullet-' + getDegreeColor(items[0].degree)"></span>
                        {{ items[0].function_name }}
                        <span class="ml-50" style="font-size: 1rem">
                          <b-badge
                            v-if="items.length > 1"
                            @click.stop="items[0].fold = !items[0].fold"
                            pill
                            :variant="'light-' + getDegreeColor(items[0].degree)"
                          >
                            {{ items[0].fold ? '- collapse' : '+' + (items.length - 1) + ' more' }}
                          </b-badge></span
                        >
                      </h5>
                      <p class="text-truncate mb-25">
                        <small>
                          <b-icon-clock-fill class="mr-25" />
                          {{ items[0].create_date }}
                          <b-icon-hdd-fill class="ml-1 mr-25"> </b-icon-hdd-fill>
                          {{ items[0].eqname }}
                          <span>
                            <b-icon icon="building" class="ml-1 mr-25"></b-icon>
                            {{ items[0].building }}
                          </span>
                          <span class="text-muted">
                            <b-icon-upc-scan class="ml-1 mr-25"></b-icon-upc-scan>
                            {{ items[0].equsid }}
                          </span>
                        </small>
                      </p>

                      <div class="text-truncate text-muted">
                        探测到{{ items[0].eqname }}存在{{ items[0].function_name }}风险，该风险来自于{{ items[0].system }}，属于{{
                          items[0].type
                        }}型故障，风险等级为{{ items[0].degree }}，可能由{{ items[0].fault_reason }}等原因造成，建议{{ items[0].fault_solution }}。
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <!-- ============ 展开的内容 ============ -->
                <hr v-if="items[0].fold" class="offsetMargin" />

                <b-list-group
                  flush
                  :style="`height: ${items[0].fold ? (items.length - 1) * 101.47 : '0'}px;`"
                  style="overflow: hidden; transition: 0.1s all ease"
                >
                  <b-list-group-item
                    @click.stop="openChat(item)"
                    @mouseenter="item.mouse_in = true"
                    @mouseleave="item.mouse_in = false"
                    :style="item.id === detailModal.data.id && selectIds.length <= 1 ? `box-sizing: border-box; border-left: 3px solid #1890ff;` : ''"
                    v-for="(item, index) of items.length > 1 ? items.slice(1, items.length) : []"
                    class="cursor-pointer px-2 py-1"
                    :key="index"
                  >
                    <b-row>
                      <b-col cols="12" class="d-flex align-items-center">
                        <div style="min-width: 0">
                          <h5 class="d-flex align-items-center">
                            <span class="bullet bullet-sm mr-1" :class="'bullet-' + getDegreeColor(item.degree)"></span>
                            {{ item.function_name }}
                          </h5>
                          <p class="text-truncate mb-25">
                            <small>
                              <b-icon-clock-fill class="mr-25" />
                              {{ item.create_date }}

                              <b-icon-hdd-fill class="ml-1 mr-25"> </b-icon-hdd-fill>
                              {{ item.eqname }}

                              <span class="text-muted">
                                <b-icon-upc-scan class="ml-1 mr-25"></b-icon-upc-scan>
                                {{ item.equsid }}
                              </span>
                            </small>
                          </p>

                          <div class="text-truncate text-muted">
                            探测到{{ item.eqname }}存在{{ item.function_name }}风险，该风险来自于{{ item.system }}，属于{{
                              item.type
                            }}型故障，风险等级为{{ item.degree }}，可能由{{ item.fault_reason }}等原因造成，建议{{ item.fault_solution }}。
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
                <!-- ============ 展开的内容结束 ============ -->
              </b-list-group-item>
            </b-list-group>
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              align="center"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </vue-perfect-scrollbar>
        </b-col>
      </b-row>
    </b-card>

    <!-- Message order -->
    <b-modal
      id="repair-list-print-modal"
      centered
      size="sm"
      title="短信推送"
      :ok-disabled="!select_alert.length"
      cancel-title="取消"
      ok-title="确认"
      @ok="handleClickPush(1)"
    >
      <b-card-text>确认将此风险消息通过短信推送至以下联系人？ </b-card-text>
      <v-select
        v-model="select_alert"
        dir="ltr"
        multiple
        placeholder="请选择联系人"
        label="title"
        :options="
          alert_list.map((item) => ({
            value: item.id,
            title: item.name,
          }))
        "
      />
    </b-modal>

    <!-- APP order -->
    <b-modal
      id="repair-list-print-modal-to-app"
      centered
      size="sm"
      title="APP推送"
      :ok-disabled="!select_alert.length"
      cancel-title="取消"
      ok-title="确认"
      @ok="handleClickPush(1)"
    >
      <b-card-text>确认将此风险消息通过APP推送至以下联系人？ </b-card-text>
      <v-select v-model="select_alert" dir="ltr" placeholder="暂无联系人" multiple label="title" />
    </b-modal>

    <b-modal id="detailsModal" v-model="showModal" title="诊断建议" centered hide-footer @close="resetDetailModal">
      <div>
        <b-card-body class="content-sidebar-header">
          <b-card-title class="text-truncate" style="display: flex; justify-content: space-between">
            <div>
              {{ detailModal.data.eqname }}
              {{ detailModal.data.function_name }}
            </div>
          </b-card-title>
          <b-card-sub-title class="text-truncate">
            <small>
              <b-icon-clock-fill class="mr-25"> </b-icon-clock-fill>
              {{ detailModal.data.create_date }}
            </small>
            <small class="ml-1">
              <b-icon-hdd-fill class="mr-25"> </b-icon-hdd-fill>
              {{ detailModal.data.eqname }}
            </small>
            <small class="ml-1">
              <b-icon-bell-fill class="mr-25"> </b-icon-bell-fill>
              {{ $t(detailModal.data.degree) }}
            </small>
            <small class="ml-1">
              <b-icon-tag-fill class="mr-25"> </b-icon-tag-fill>
              {{ $t(detailModal.data.type) }}
            </small>
          </b-card-sub-title>
        </b-card-body>
        <vue-perfect-scrollbar style="height: calc(54vh)">
          <b-card-body>
            <b-card bg-variant="light-secondary">
              建研查微风险探针于<span class="text-info">{{ detailModal.data.create_date }}</span
              >探测到<span class="text-info">{{ detailModal.data.eqname }}</span
              >（<span class="text-info">#{{ detailModal.data.equsid }}</span
              >）存在<span class="text-info">{{ detailModal.data.function_name }}</span
              >风险，该风险来自于<span class="text-info">{{ detailModal.data.system }}</span
              >，属于<span class="text-info">{{ detailModal.data.type }}</span
              >型故障，风险等级为<span :class="'text-' + getDegreeColor(detailModal.data.degree)">{{ detailModal.data.degree }}</span
              >。
            </b-card>
            <b-card bg-variant="light-success">
              <h5 class="text-success mb-50">根因分析</h5>
              <p style="margin-bottom: 0.5rem">该风险可能是由于以下原因造成：</p>
              <div style="white-space: pre-line">
                <!--                    <div>-->
                {{ detailModal.data.fault_reason }}
              </div>
            </b-card>
            <b-card bg-variant="light-info">
              <h5 class="text-info mb-50">解决建议</h5>
              <p style="margin-bottom: 0.5rem">为了避免此类风险，你可以尝试以下措施：</p>
              <div style="white-space: pre-line">
                <!--                    <div>-->
                {{ detailModal.data.fault_solution }}
              </div>
            </b-card>
            <footer class="blockquote-footer text-right mt-2">
              <small class="text-muted"> 以上诊断结论由建研查微专家系统提供 </small>
            </footer>
          </b-card-body>
        </vue-perfect-scrollbar>
        <hr class="my-0" />
        <div class="pt-50 pb-50 px-1">
          <div class="d-flex align-items-center justify-content-between btnlist">
            <b-button variant="flat-primary" size="sm" class="btn-icon" v-b-modal:repair-list-print-modal>
              <b-icon-chat-fill />
              短信推送
            </b-button>
            <b-button variant="flat-primary" size="sm" class="btn-icon wechat" @click="handlePushWechat(detailModal.data)">
              <i class="bi-wechat" style="font-size: 1rem"></i>
              微信推送
            </b-button>
            <b-button variant="flat-primary" size="sm" class="btn-icon" v-b-modal:repair-list-print-modal-to-app>
              <b-icon-app-indicator />
              APP推送
            </b-button>
            <b-button
              :disabled="detailModal.data.state == 2"
              variant="flat-primary"
              size="sm"
              class="btn-icon"
              @click.stop="handleClickPush(2, detailModal.data)"
            >
              <b-icon-trash-fill />
              忽略
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { computed, reactive, toRefs, ref, watch, nextTick, onMounted } from '@vue/composition-api';
import { showToast } from '@/libs/utils/showToast';
import { getFaultAgentsFold, getFaultAgentsLeftLevel } from '@/api/front';
import {
  getDiagnosisAlertList,
  getDiagnosisHandleDetail,
  getDiagnosisHandleEvent,
  getDiagnosisOptions,
  getDiagnosisSendWechatNotice,
} from '@/api/diagnosis';
import { momentJs } from '@/libs/utils/moment';
import vSelect from 'vue-select';
import { routerParams } from '@/libs/utils/routerParams';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { BSidebar } from 'bootstrap-vue';
import { isNull } from 'lodash';
import { showConfirm } from '@/libs/utils/showConfirm';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { getCurrentInstance } from '@vue/composition-api';

export default {
  components: {
    vSelect,
    VuePerfectScrollbar,
    BSidebar,
  },
  setup() {
    const vm = getCurrentInstance().proxy;
    const event = reactive({
      recordInfoShow: false,
      chartTab: 0,
      function_names: [],
      fault_level_3: 0,
      fault_level_2: 0,
      fault_level_1: 0,
      fault_cate_3: 0,
      fault_cate_2: 0,
      fault_cate_1: 0,
      count_state: [0, 0, 0],
      project_id: computed(() => {
        return routerParams('project_id');
      }),
      filterOptions: {},
      filterValues: {
        degree: null,
        state: 0,
        system: '',
        time: `${momentJs().format().split('T')[0]}` + ' ' + '至' + ' ' + `${momentJs().format().split('T')[0]}`,
        building: '',
        eqname: '',
        timeOrderBy: 'desc',
        function_name: null,
        category: ['连续恒值', '无效点过多', '报警检查'],
        current_function_id: 'null',
      },
      isEditAgentSidebarActive: false,
      refAgentListTable: null,
      perPage: 20,
      searchQuery: '',
      tableColumns: [
        {
          label: '#',
          key: 'index',
        },
        {
          label: '故障名称',
          key: 'fault_name',
        },
        {
          label: '故障程度',
          key: 'degree',
        },
        {
          label: '故障等级',
          key: 'primary_class',
          sortable: true,
        },
        {
          label: '方程名称',
          key: 'function_name',
        },
        {
          label: '所属系统',
          key: 'system',
        },
        {
          label: '故障时间',
          key: 'create_date',
        },
        {
          label: '操作',
          key: 'actions',
        },
      ],
      total: 0,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 100],
      sortBy: 'create_date',
      isSortDirDesc: true,
      dataMeta: computed(() => {
        const localItemsCount = 10;
        return {
          from: event.perPage * (event.currentPage - 1) + (localItemsCount ? 1 : 0),
          to: event.perPage * (event.currentPage - 1) + localItemsCount,
          of: event.total,
        };
      }),
      detailModal: {
        show: false,
        data: {},
        chatContent: '',
        chats: [],
        chats_gpt: [],
        chats_deepseek: [],
        chats_baidu: [],
        chatMessageLoading: '',
        reasoning_content: '',
        current_session: {
          is_chat_send: false,
          is_baidu_send: false,
          is_deepseek_send: false,
          content: '',
        },
      },
      isBusy: false,
    });
    const dataList = ref([]);
    const loading = ref(true);
    const fault_name = ref('');
    const rightInfoTabIndex = ref(1);
    const isAllSelected = ref(false);
    const selectIds = ref([]);
    const degree_pie = ref(null);
    const tabSelect = ref(2);
    const alert_list = ref([]);
    const select_alert = ref([]);
    const showChat = ref(JSON.parse(localStorage.getItem('showChat') || 'true'));
    const showModal = ref(false);
    watch(showModal, (newVal) => {
      if (newVal) {
        // sidebar 打开时禁止背景滚动
        document.body.classList.add('no-scroll');
      } else {
        // sidebar 关闭时恢复背景滚动
        document.body.classList.remove('no-scroll');
      }
    });
    watch([() => event.currentPage, () => event.perPage, () => event.isEditAgentSidebarActive, () => event.searchQuery], () => {
      if (!event.isEditAgentSidebarActive) {
        fetchAgents();
      }
    });
    getDiagnosisAlertList().then((res) => {
      alert_list.value = res.data;
    });
    /**
     * 打开诊断弹窗
     * @param detail
     */
    const openChat = (detail) => {
      getDiagnosisHandleDetail(detail.id).then((res) => {
        event.detailModal.chatContent = `${detail.create_date}，${detail.system}中的${detail.eqname}，出现${detail.function_name}的故障，是什么原因导致的？有什么解决方案？`;
        event.detailModal.show = false;
        event.detailModal.data = {};
        rightInfoTabIndex.value = 1;
        event.detailModal.chats = [];
        detail.data = res.data ? res.data.data : {};
        event.detailModal.chatMessageLoading = '';
        showModal.value = true;
        nextTick(() => {
          if (selectIds.value.length <= 1) {
            event.detailModal.show = true;
            event.detailModal.data = detail;
          }
        });
      });
    };
    /**
     * 关闭弹窗后重置数据
     */
    const resetDetailModal = () => {
      event.detailModal = {
        show: false,
        data: {},
        chatContent: '',
        reasoning_content: '',
        chats_gpt: [],
        chats_baidu: [],
        chats_deepseek: [],
        current_session: {
          is_chat_send: false,
          is_baidu_send: false,
          is_deepseek_send: false,
          content: '',
        },
        chats: [
          // {
          //   "role": "system",
          //   "content": "Hi，我是建研查微智能诊断机器人，欢迎向我咨询问题👏🏻"
          // },
        ],
        chatMessageLoading: '',
      };
    };
    /**
     * 请求数据
     */
    const fetchAgents = () => {
      event.isBusy = true;
      dataList.value = [];
      const filters = getFilters();
      const params = {
        project_id: event.project_id,
        pagesize: event.perPage,
        page: event.currentPage,
        sortBy: event.sortBy,
        sortDesc: event.isSortDirDesc ? 1 : 0,
        fault_name: fault_name.value,
        ...filters,
      };
      getFaultAgentsLeftLevel(params).then((res) => {
        const { level_1, level_2, level_3 } = res.data;
        event.fault_level_1 = level_1;
        event.fault_level_2 = level_2;
        event.fault_level_3 = level_3;
      });
      getList(params)
        .then((response) => {
          const {
            list,
            total,

            function_ids,
            current_function_id,
            cate_1,
            cate_2,
            cate_3,
            count_state,
          } = response.data;
          event.filterValues.current_function_id = current_function_id;
          dataList.value = list.map((items) => {
            items[0].fold = false;
            items.forEach((item) => {
              item.mouse_in = false;
            });
            return items;
          });
          event.total = total;
          event.function_names = [
            {
              function_name: '全部',
              function_id: 'null',
              total: event.fault_level_1 + event.fault_level_2 + event.fault_level_3,
            },
            ...function_ids,
          ];
          event.fault_cate_1 = cate_1;
          event.fault_cate_2 = cate_2;
          event.fault_cate_3 = cate_3;
          event.count_state = count_state;
          if (!total) {
            showToast(null, '提示', '未查询到数据');
          }
          event.isBusy = false;
        })
        .catch((error) => {
          event.isBusy = false;
          showToast(error);
        })
        .finally(() => {
          loading.value = false;
        });
    };
    /**
     * 获取列表数据
     */
    const getList = async (params) => {
      return getFaultAgentsFold({
        project_id: event.project_id,
        ...params,
      });
    };
    /**
     * 获取参数
     */
    const getOptions = () => {
      return getDiagnosisOptions({
        project_id: event.project_id,
      })
        .then((response) => {
          event.filterOptions = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    /**
     * 获取筛选条件
     */
    const getFilters = () => {
      let filters = {};
      for (const Key in event.filterValues) {
        let Value = event.filterValues[Key];
        if (Key === 'state' && !isNull(Value)) {
          filters.state = Value;
          continue;
        }
        if (Key === 'current_function_id') {
          filters.function_id = String(Value);
          continue;
        }
        if (!!Value) {
          filters[Key] = Value;
          if (Key === 'time') {
            Value = Value.replaceAll(' 至 ', ',').replaceAll(' to ', ',');
            const timeArr = Value.split(',');
            const start = momentJs(timeArr[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
            const end = momentJs(timeArr[1] || timeArr[0])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss');
            filters[Key] = '(' + start + ',' + end + ')';
          }
        }
      }
      return filters;
    };
    const handleBatchPush = (v, selectids) => {
      getDiagnosisHandleEvent({
        ids: [...selectids],
        state: v,
        alert_list: select_alert.value.map((item) => item.value),
      }).then(() => {
        const flatDataList = [];
        dataList.value.forEach((items) => items.forEach((item) => flatDataList.push(item)));
        for (let item of flatDataList) {
          if (selectids.includes(item.id)) {
            item.state = v;
          }
        }
        selectIds.value = [];
        isAllSelected.value = false;
      });
    };
    const getDegreeColor = (degree) => {
      switch (degree) {
        case '一般':
          return 'warning';
        case '提醒':
          return 'info';
        case '紧急':
          return 'danger';
      }
    };
    const getTypeColor = (type) => {
      switch (type) {
        case '安全':
          return 'primary';
        case '舒适':
          return 'info';
        case '节能':
          return 'success';
        default:
          return 'secondary';
      }
    };
    const getStateColor = (state) => {
      switch (state) {
        case 0:
          return 'warning';
        case 1:
          return 'success';
        case 2:
          return 'secondary';
      }
    };
    const handleClickPush = (state = 1, data = event.detailModal.data) => {
      event.detailModal.data = data;
      const ids = [];
      if (state === 2) {
        showConfirm(vm, '确认忽略选择消息？', () => {
          if (data) {
            ids.push(data.id);
          }
          handleBatchPush(2, ids);
          fetchAgents();
        });
        return;
      }
      if (data) {
        ids.push(data.id);
      }
      handleBatchPush(state, ids);
    };
    /**
     * 微信推送
     * @param item
     */
    const handlePushWechat = (item = null) => {
      if (!item && !selectIds.value.length) {
        return showToast(null, '提示', '未选中任何信息');
      }
      let ids = [];
      select_alert.value = [];
      if (!item) {
        ids = [...selectIds.value];
      } else {
        ids = [item.id];
        event.detailModal.data = item;
      }
      showConfirm(
        vm,
        '确认将此风险消息通过微信推送至所有联系人？',
        () => {
          getDiagnosisSendWechatNotice({
            ids,
            state: 1,
          }).then(() => {
            if (item.state == 0) item.state = 1;
          });
          // updateLayout();
        },
        null,
        true,
        'https://simulation-1255710621.cos.ap-nanjing.myqcloud.com/assets/images/wechat.svg',
        null
      );
    };
    // 处理URL中的token参数
    const handleTokenFromUrl = () => {
      return new Promise((resolve) => {
        const params = new URLSearchParams(location.search);
        if (params.get('token')) {
          localStorage.setItem('accessToken', params.get('token'));
          params.delete('token');
          const newUrl = params.toString() ? `${location.pathname}?${params.toString()}` : location.pathname;
          window.history.replaceState({}, document.title, newUrl);
        }
        resolve();
      });
    };
    onMounted(async () => {
      await handleTokenFromUrl();
      getOptions().then(() => {
        fetchAgents();
      });
    });
    return {
      ...toRefs(event),
      handleBatchPush,
      getOptions,
      isAllSelected,
      fault_name,
      selectIds,
      handlePushWechat,
      dataList,
      loading,
      degree_pie,
      alert_list,
      select_alert,
      rightInfoTabIndex,
      getDegreeColor,
      getTypeColor,
      getStateColor,
      handleClickPush,
      tabSelect,
      showChat,
      showModal,
      openChat,
      resetDetailModal,
    };
  },
};
</script>

<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';

.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

#detailsModal {
  padding: 0.8rem;
  .modal-body {
    // height: 70vh;
    overflow: auto;
    padding: 0;
  }
}

.btnlist {
  .btn {
    height: 2.5rem;
  }
  .btn.btn-icon {
    padding: 0.5rem 0.2rem;
    .b-icon {
      font-size: 100%;
      margin-bottom: 1px;
    }
  }
  .btn.btn-icon.wechat {
    padding-bottom: 0.65rem !important;
  }
}

.no-scroll {
  overflow: hidden;
}
</style>
